"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IS_CLIENT = typeof window !== "undefined";
exports.default = IS_CLIENT ? require("sa-sdk-javascript") : require("./server");
